export default "__VITE_ASSET__Cs_GFKFQ__"